import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AdaCustomization } from 'core/models/ada-customization';

@Component({
  selector: 'lms-customization-create',
  templateUrl: './customization-create.component.html',
  styleUrls: ['./customization-create.component.scss']
})
export class CustomizationCreateComponent implements OnInit {
  constructor(public location: Location, public router: Router) {}

  ngOnInit() {}

  onSave(customization: AdaCustomization) {
    this.router.navigate(['/customizations', customization.id]);
  }

  cancel() {
    this.location.back();
  }

  goBack(): void {
    this.router.navigate(['/customizations']);
  }
}
